<template>
  <div class="card" v-if="plan">
    <div class="card-header">
      <h3>Payment plan</h3>
    </div>
    <div class="card-body">
      <table class="table">
        <tbody>
          <tr>
            <th scope="row">Name</th>
            <td>{{ plan.name }}</td>
          </tr>
          <tr>
            <th scope="row">Price</th>
            <td>{{ plan.price }}</td>
          </tr>
          <tr>
            <th scope="row">Start payment</th>
            <td>{{ plan.start_payment }}</td>
          </tr>
          <tr>
            <th scope="row">Next payment</th>
            <td>{{ plan.next_payment }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'account-payment-plan',
  computed: {
    plan() {
      return this.$store.getters.paymentPlan
    }
  }
}
</script>

<style></style>
